import React, { useEffect } from 'react';
import styles from './Start.module.scss';
import AppLink from '@components/AppLink/AppLink';
import RatingsCarousel from '@views/Start/RatingsCarousel';
import cn from 'classnames';
import analytics from '@repo/utils/helpers/analytics';
import { useTheme } from '@repo/themes';

export default function Start() {
  const [theme] = useTheme();

  useEffect(() => {
    analytics.trackStartPage('welcome');
    document.querySelector('body').classList.add('start-page');

    return () => {
      document.querySelector('body').classList.remove('start-page');
    };
  }, []);

  return (
    <div className={cn(styles.startPage, styles[theme])}>
      <h1>Welcome to Clay</h1>
      <p />
      <AppLink app="macos" />
      <AppLink app="windows" />
      <AppLink app="ios" />
      <AppLink app="web" />
      <RatingsCarousel />
    </div>
  );
}
